module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_7005.0b48ca07.png";